import axios from 'axios';
import store from 'src/store';
import { selectAuthToken } from 'src/store/selectors/authSelectors';
import { getLocalStorage } from 'src/utils/localStorage';

if (!process.env.REACT_APP_API_BASE) {
  console.error(
    'REACT_APP_API_BASE variable not loaded properly. Check your .env file please!'
  );
}

const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  timeout: 30000
});

client.interceptors.request.use(config => {
  const stateToken = selectAuthToken(store.getState());
  const temporalToken = getLocalStorage('temporalToken');

  // Use temporalToken if explicitly requested via config metadata
  // This allows services to specify which token to use without hardcoding endpoint logic
  const useTemporalToken = config.useTemporalToken === true;
  const useAvalToken = config.useAvalToken === true;

  if (useAvalToken) {
    const avalTemporalToken = getLocalStorage('avalTemporalToken');
    config.headers.Authorization = `Bearer ${avalTemporalToken}`;
  } else if (useTemporalToken && temporalToken) {
    config.headers.Authorization = `Bearer ${temporalToken}`;
  } else {
    config.headers.Authorization = `Bearer ${stateToken || temporalToken}`;
  }

  return config;
});

client.interceptors.response.use(
  response => response,
  error => {
    const { config, response } = error;
    const isAuthError =
      response?.status === 401 || response?.status === 403;

    if (config?.useAvalToken && isAuthError) {
      localStorage.removeItem('avalTemporalToken');
    }

    return Promise.reject(error);
  }
);

export default client;
